import { Cookie } from '@dtx-company/true-common/src/utils/cookies'
import { FUNCTIONAL_COOKIE_PATTERN } from '@dtx-company/true-common/src/utils/cookies/cookies.constants'
import { setDemo } from '@dtx-company/inter-app/src/redux/slices/current-session-slice'
import { useCookies } from '@dtx-company/true-common/src/utils/cookies/cookies.hooks'
import { useDispatch } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import { useIsEU } from './useCheckEU'
import { useOneTrustConsentListener } from './useOneTrustConsentListener'
import { useRouter } from 'next/router'

export const OneTrustDemoListener =
  (setEnableDemoCookie: (enableDemoCookie: boolean) => void) => (): void => {
    const hasUserEnabledFunctionalCookies =
      window.OptanonActiveGroups?.match(FUNCTIONAL_COOKIE_PATTERN)
    if (hasUserEnabledFunctionalCookies) {
      setEnableDemoCookie(true)
    }
  }

export const useIsDemo = (): void => {
  const router = useRouter()
  const { setCookie } = useCookies()
  const dispatch = useDispatch()
  const [enableDemoCookie, setEnableDemoCookie] = useState(false)
  const { isEULoaded, isEU } = useIsEU()
  const isDemo = router.query.demo === 'true'
  const listener = useMemo(() => OneTrustDemoListener(setEnableDemoCookie), [])

  useOneTrustConsentListener(listener)

  useEffect(() => {
    if (!isEULoaded || (isEU && !enableDemoCookie)) {
      return
    }

    setCookie(Cookie.demo, isDemo)
    dispatch(
      setDemo({
        demo: isDemo
      })
    )
  }, [isDemo, dispatch, enableDemoCookie, setCookie, isEULoaded, isEU])
}
